import { call, put, fork, takeEvery, select, throttle } from 'redux-saga/effects';
// import TIM from 'tim-js-sdk-ws';
import { StaticToast } from 'src/components/common';
import TIMSDKIM from 'src/utils/tim/index';
import validate from 'src/utils/validate';
import { ImActionTypes, timSdkDataDynamicUpdate, timSdkGetHistoryMessageList, updateIMMessageStatus } from './action';
import { aliPaycustomSendImageMessageData } from './utils';

function* sagaIMHistoryMsgList(action: any) {
  try {
    const { payload: { success = null } = {} } = action;
    const { timSdkConfig: { currentConversationID = '' } = {}, timGroupChat: { nextReqMessageID: prevId = '' } = {} } = yield select((state) => state.ims || {});
    const res = yield call(() => TIMSDKIM.tim.getMessageList({ conversationID: `GROUP${currentConversationID}`, nextReqMessageID: prevId, count: 15 }));
    const { nextReqMessageID = '', messageList = [], isCompleted } = res.data;
    console.log('请求历史数据', res);
    yield put({
      type: ImActionTypes.TIMSDK_GET_HISTORY_UNSHIFTMESSAGELIST,
      data: {
        list: messageList,
        isMore: !isCompleted,
        nextReqMessageID,
      },
    });
    success && success();
  } catch (err) {
    const error: any = err;
    error && error.message && StaticToast.error(error.message);
  }
}

export function* getSagaIMHistoryMsgList() {
  yield takeEvery(ImActionTypes.TIMSDK_GET_HISTORY_MESSAGELIST, sagaIMHistoryMsgList);
}
function* sagaIMGroupList(action: any) {
  // const { payload: { username = '', password = '', groupId = '' } = {} } = action;
  try {
    const res = yield call(() => TIMSDKIM.tim.getGroupList());
    const { timSdkConfig = {} } = yield select((state) => state.ims || {});
    const { code = '', data = {} } = res;
    console.log('**** 群列表', res);
    if (code === 0) {
      const { groupList = [] } = data;
      const currentGroup = groupList.find((k) => k.groupID == timSdkConfig.currentConversationID) || {};
      if (currentGroup.groupID || timSdkConfig.currentConversationID) {
        console.log('**** 1、开始申请加群');

        const joinGroupRes = yield call(() => TIMSDKIM.tim.joinGroup({ groupID: timSdkConfig.currentConversationID, applyMessage: '我想申请加入贵群，望批准！' }));
        const { status = '' } = joinGroupRes.data || {};
        if (status == window.TIM.TYPES.JOIN_STATUS_SUCCESS || status == window.TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP) {
          console.log('**** 2、加入成功', res);
          // 匹配到群聊
          yield put(timSdkDataDynamicUpdate({ timIsGroupReady: true }));
          // 开始拉取历史消息
          yield put(timSdkGetHistoryMessageList({}));
          return;
        } else {
          console.log('**** 3、特别处理，已经达到最高阀值 ,加入群聊没有成功，请查看状态', res.data);
        }
      }
    }
    yield put(timSdkDataDynamicUpdate({ timIsGroupReady: false }));
  } catch (err) {
    const error: any = err;
    error && error.message && StaticToast.error(error.message);
  }
}

export function* getSagaIMGroupList() {
  // yield takeEvery(ImActionTypes.TIMSDK_GET_GROUPLIST, sagaIMGroupList);
  yield throttle(800, ImActionTypes.TIMSDK_GET_GROUPLIST, sagaIMGroupList);
}

// 发送文本消息
function* sagaSendIMTxtMessage(action: any) {
  const { payload: { message: { msg = '' } = {} } = {} } = action;
  try {
    const { timSdkConfig: { currentConversationID = '', currentConversationType = '' } = {}, timIsGroupReady = false } = yield select((state) => state.ims || {});
    if (!timIsGroupReady) {
      StaticToast.error('IM聊天初始失败，无发发送消息');
      return;
    }
    const message = TIMSDKIM.tim.createTextMessage({
      to: `${currentConversationID}`,
      conversationType: currentConversationType,
      payload: { text: `${msg}` },
      status: 'sending',
    });
    yield put({
      type: ImActionTypes.TIMSDK_RECEIVEMESSAGE,
      data: {
        list: [message],
        triggerScroll: true,
      },
    });

    const res = yield call(() => TIMSDKIM.tim.sendMessage(message));
    const { code } = res;
    const result = {
      clientSequence: message.clientSequence,
      status: 'sent',
      err: '',
    };
    if (code === 0) {
      result.status = 'sent';
    } else {
      result.err = 'error';
      result.status = 'fail';
    }
    yield put(updateIMMessageStatus(result));
  } catch (err) {
    const error: any = err;
    error && error.message && StaticToast.error(error.message);
  }
}

export function* sendTIMSDKTxtMessaget() {
  yield takeEvery(ImActionTypes.TIMSDK_SEND_IMTXT_MESSAGE, sagaSendIMTxtMessage);
}

// 发送图片消息
function* sagaSendIMImageMessage(action: any) {
  const { payload = {} } = action;
  try {
    const { timSdkConfig: { currentConversationID = '', currentConversationType = '' } = {}, timIsGroupReady = false } = yield select((state) => state.ims || {});
    if (!timIsGroupReady) {
      StaticToast.error('IM聊天初始失败，无发发送消息');
      return;
    }
    const baseOpts = {
      to: `${currentConversationID}`,
      conversationType: currentConversationType,
      status: 'sending',
    };
    let message = { clientSequence: {} };
    // 支付宝 部分手机不兼容，改为自定义消息，图片会用原生组件先上传完
    if (validate.isAlipayApplet() && payload.link) {
      const cloudCustomData = aliPaycustomSendImageMessageData(payload.link);
      message = TIMSDKIM.tim.createCustomMessage({ ...baseOpts, cloudCustomData, payload: { description: '自定义图片消息' } });
    } else {
      message = TIMSDKIM.tim.createImageMessage({ ...baseOpts, payload: { file: payload } });
    }
    /* const message = TIMSDKIM.tim.createImageMessage({
      to: `${currentConversationID}`,
      conversationType: currentConversationType,
      payload: { file: payload },
      status: 'sending',
    });*/

    yield put({
      type: ImActionTypes.TIMSDK_RECEIVEMESSAGE,
      data: {
        list: [message],
        triggerScroll: true,
      },
    });

    const res = yield call(() => TIMSDKIM.tim.sendMessage(message));
    const { code } = res;
    const result = {
      clientSequence: message.clientSequence,
      status: 'sent',
      err: '',
    };
    if (code === 0) {
      result.status = 'sent';
    } else {
      result.err = 'error';
      result.status = 'fail';
    }
    yield put(updateIMMessageStatus(result));
  } catch (err) {
    const error: any = err;
    error && error.message && StaticToast.error(error.message);
  }
}

export function* sendTIMSDKImageMessaget() {
  yield takeEvery(ImActionTypes.TIMSDK_SEND_IMIMAGE_MESSAGE, sagaSendIMImageMessage);
}

export default [fork(getSagaIMGroupList), fork(getSagaIMHistoryMsgList), fork(sendTIMSDKTxtMessaget), fork(sendTIMSDKImageMessaget)];
